(function () {
  const TAG_SCALE_BY_COUNT = [1, 0.97, 0.9, 0.82, 0.74];
  const CHARM_SCALE_BY_COUNT = [1, 0.97, 0.9, 0.82, 0.74];
  // Profondità (px) del "pendaglio" di ogni slot lungo la collana, dall'esterno
  // verso l'interno: gli slot vicini alla targhetta pendono più in basso.
  const SLOT_MAX_DEPTH = 92; // profondità (px) dello slot più interno; l'esponente modella la curva
  // Ciondolini più grandi in anteprima (Luca 01/08: «i ciondoli un po' più
  // grandi»). +20% sul diametro: si vedono meglio apetta, cuore & co. senza
  // che la targhetta con la frase perda il ruolo di protagonista. È il valore
  // a cui si PUNTA — chi lo applica verifica prima che ci stia (renderSlotsOnCurve).
  const CHARM_ENLARGE = 1.2;
  // Passo minimo fra due ciondolini, in multipli del loro diametro: sotto 1
  // i riquadri si sovrappongono, quindi 1.02 è il "si sfiorano ma non si
  // toccano" oltre il quale non si comprime mai.
  const CHARM_MIN_GAP = 1.02;
  const SHAPE_LABELS = {
    quadrata: 'quadrata',
    rotonda: 'rotonda',
    orizzontale: 'orizzontale',
    rettangolare: 'rettangolare',
  };

  function esc(str) {
    const div = document.createElement('div');
    div.textContent = String(str);
    return div.innerHTML;
  }

  function fmtMoney(cents) {
    return new Intl.NumberFormat('it-IT', {
      style: 'currency',
      currency: 'EUR',
    }).format(cents / 100);
  }

  // "+3 €" e non "+3,00 €": sul badge dello swatch e nelle label i decimali
  // a zero sono solo rumore; se il supplemento un giorno avra' centesimi,
  // ricompaiono da soli.
  function fmtMoneyCompact(cents) {
    return cents % 100 === 0 ? `${cents / 100} €` : fmtMoney(cents);
  }

  function getData(root) {
    const el = root.querySelector('[data-gg-frasi-config]');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  // Curva reale della collana fotografata (estratta offline dalle foto ufficiali,
  // vedi gg-frasi-curves.js): punti [x,y] normalizzati 0..1 sull'inquadratura.
  function curveForPhoto(src) {
    const map = window.GG_FRASI_CURVES || {};
    if (!src) return null;
    const base = src.split('/').pop().split('?')[0].replace(/\.(jpg|jpeg|png|webp)$/i, '');
    return map[base] || null;
  }

  // Tabella per camminare lungo la curva a distanza d'arco costante:
  // campiona la polilinea e accumula le lunghezze (in px del layer).
  function buildArcTable(pts, w, h) {
    const P = pts.map((p) => ({ x: p[0] * w, y: p[1] * h }));
    const cum = [0];
    for (let i = 1; i < P.length; i++) {
      cum[i] = cum[i - 1] + Math.hypot(P[i].x - P[i - 1].x, P[i].y - P[i - 1].y);
    }
    // posizione (x,y) alla distanza d'arco s
    const at = (s) => {
      if (s <= 0) return P[0];
      if (s >= cum[cum.length - 1]) return P[P.length - 1];
      let i = 1;
      while (cum[i] < s) i++;
      const t = (s - cum[i - 1]) / (cum[i] - cum[i - 1] || 1);
      return {
        x: P[i - 1].x + (P[i].x - P[i - 1].x) * t,
        y: P[i - 1].y + (P[i].y - P[i - 1].y) * t,
      };
    };
    // distanza d'arco del punto della curva più vicino a x orizzontale dato
    const sAtX = (x) => {
      let best = 0;
      let bestDx = Infinity;
      for (let i = 0; i < P.length; i++) {
        const dx = Math.abs(P[i].x - x);
        if (dx < bestDx) {
          bestDx = dx;
          best = cum[i];
        }
      }
      return best;
    };
    return { at, sAtX, total: cum[cum.length - 1] };
  }

  // Le varianti del prodotto sono "Targhetta {Forma} / {Base} / {Colore}":
  // option1 = forma targhetta, option2 = base (Catena/Cordino/Perline), option3 = colore.
  const BASE_OPT = { cordino: 'cordino', perline: 'perline', catenina: 'catena' };

  function normStr(s) {
    return String(s || '').toLowerCase();
  }

  // Vincoli testo (call 18/07, righe allargate 24/08): max 3 righe, max 12
  // char/riga. CHARS_MAX e' un vincolo fisico A SE' (quanto ci sta inciso
  // sulla targhetta) e non piu' derivato da LINE_MAX*LINES_MAX (Marco 24/08:
  // con righe da 12 la formula darebbe 36, ma il budget di incisione resta
  // 30 indipendentemente da come il testo va a capo).
  const LINE_MAX = 12;
  const LINES_MAX = 3;
  // I caratteri incisi sono quelli che finiscono sulla targhetta: gli spazi
  // fra le parole che il wrapping trasforma in a capo non si vedono e non
  // devono consumare budget (call 30/07, il testo si fermava intorno ai 26).
  // Budget interno alzato a 32 (Marco 24/08, pattern "parole corte pagano
  // piu' spazi": frasi come "Custodisci il sale che hai dentro" arrivano a
  // 31 di minimo matematico pur restando leggibili) — la scritta sotto il
  // campo resta "/30" di proposito, il margine e' invisibile all'utente.
  const CHARS_MAX = 32;
  // caratteri effettivamente incisi: le righe senza gli a capo che le separano
  function usefulLength(lines) {
    return lines.join('').length;
  }
  function wrapPhrase(str) {
    const words = String(str || '').trim().split(/\s+/).filter(Boolean);
    const lines = [];
    let cur = '';
    const pushCur = () => {
      if (cur) {
        lines.push(cur);
        cur = '';
      }
    };
    words.forEach((word) => {
      let w = word;
      while (w.length > LINE_MAX) {
        pushCur();
        lines.push(w.slice(0, LINE_MAX));
        w = w.slice(LINE_MAX);
      }
      if (!w) return;
      if (!cur) cur = w;
      else if (cur.length + 1 + w.length <= LINE_MAX) cur += ' ' + w;
      else {
        pushCur();
        cur = w;
      }
    });
    pushCur();
    return lines;
  }

  // Prefisso piu' lungo di str che rientra ancora nel limite (call Marco
  // 24/08, bug B3): usato quando il testo digitato/incollato non ci sta
  // piu', al posto di tornare all'ultimo valore SALVATO — che con un
  // incolla in un colpo solo (state ancora vuoto) svuotava il campo intero
  // senza che il cliente capisse perche'.
  function truncateToFit(str) {
    let s = String(str || '');
    while (s.length > 0) {
      const lines = wrapPhrase(s);
      if (lines.length <= LINES_MAX && usefulLength(lines) <= CHARS_MAX) {
        return s;
      }
      s = s.slice(0, -1);
    }
    return '';
  }

  // "Multicolor" non è un colore piatto (fix call 18/07, confermato da Luca il
  // 01/08): si riconosce dal NOME, non da un hex speciale, così Eli può
  // rinominarlo o spostarlo dall'editor senza che il tema smetta di capirlo.
  function isMulticolor(c) {
    return normStr(c && c.name).indexOf('multicolor') !== -1;
  }

  // Il gradiente arcobaleno vive tutto in CSS (--gg-frasi-rainbow): così il
  // pallino di scelta e la scritta in anteprima pescano dalle stesse tinte e
  // non possono divergere quando se ne ritocca una.
  function paintSwatch(sw, c) {
    if (isMulticolor(c)) {
      sw.classList.add('is-multicolor');
      sw.style.background = '';
    } else {
      sw.classList.remove('is-multicolor');
      sw.style.background = c.hex;
    }
  }

  // Variante esatta dello stato: forma + base + colore, con fallback progressivo.
  // La base puo' stare su option2 (prodotto storico: "Targhetta X / Cordino /
  // Colore", 80 varianti) o su option1 (prodotto nuovo "Collanina Frasi":
  // unica opzione Cordino/Perline/Catenina) — si prova nell'ordine.
  // 'caten' matcha sia "Catena" sia "Catenina".
  function findVariantByState(variants, state) {
    const base = BASE_OPT[state.cord] || state.cord;
    const baseKey = base === 'catena' ? 'caten' : base;
    const shape = normStr(state.shape);
    const color = normStr(state.color);
    let byBase = variants.filter((v) => normStr(v.option2).includes(baseKey));
    if (!byBase.length) {
      byBase = variants.filter((v) => normStr(v.option1).includes(baseKey));
    }
    const byShape = byBase.filter((v) => normStr(v.option1).includes(shape));
    return (
      byShape.find((v) => normStr(v.option3) === color) ||
      byShape[0] ||
      byBase[0] ||
      null
    );
  }

  class GgFrasiConfigurator {
    constructor(root) {
      this.root = root;
      this.data = getData(root);
      if (!this.data) return;

      // mappa ciondolini dai blocchi sezione: key → {name, variantId, price, image}
      this.charms = {};
      (Array.isArray(this.data.charms) ? this.data.charms : []).forEach((c) => {
        if (c && c.key) this.charms[c.key] = c;
      });

      this.slotsPerSide = Math.max(2, Math.min(5, Number(this.data.slotPerSide) || 3));
      this.maxCharms = this.slotsPerSide * 2;

      this.state = {
        cord: 'cordino',
        color: '',
        colorHex: '',
        shape: 'quadrata',
        frase: '',
        textColor: null,
        // ordine di piazzamento (call 18/07: niente drag & drop, posizione automatica)
        order: [],
        slots: new Array(this.maxCharms).fill(null),
      };

      // Marco 02/09: la foto della targhetta (applyTagPhoto) carica in modo
      // asincrono. Chi vuole avviare l'animazione di caduta deve aspettare
      // che sia pronta (dimensioni reali applicate), non solo che sia
      // "iniziata" — vedi onTagPhotoReady più sotto.
      this._tagPhotoReady = false;
      this._tagPhotoReadyCbs = [];

      this.els = {
        config: root.querySelector('[data-frasi-config]'),
        preview: root.querySelector('[data-frasi-preview]'),
        previewStage: root.querySelector('[data-frasi-preview-stage]'),
        previewScale: root.querySelector('.gg-frasi-preview__scale'),
        word: root.querySelector('[data-frasi-word]'),
        tag: root.querySelector('[data-frasi-tag]'),
        strand: root.querySelector('[data-frasi-strand]'),
        slotsLeft: root.querySelector('[data-frasi-slots-left]'),
        slotsRight: root.querySelector('[data-frasi-slots-right]'),
        progTxt: root.querySelector('[data-frasi-prog-txt]'),
        progBar: root.querySelector('[data-frasi-prog-bar]'),
        input: root.querySelector('[data-frasi-input]'),
        count: root.querySelector('[data-frasi-count]'),
        note: root.querySelector('[data-frasi-note]'),
        textColors: root.querySelector('[data-frasi-textcolors]'),
        cordSelect: root.querySelector('[data-frasi-cord-select]'),
        colorSelect: root.querySelector('[data-frasi-color-select]'),
        summary: root.querySelector('[data-frasi-summary]'),
        prices: root.querySelectorAll('[data-frasi-price]'),
        klarna: root.querySelector('[data-frasi-klarna]'),
        klarnaRate: root.querySelector('[data-frasi-klarna-rate]'),
        addBtn: root.querySelector('[data-frasi-add-cart]'),
        error: root.querySelector('[data-frasi-error]'),
        steps: root.querySelectorAll('[data-frasi-step]'),
      };

      this.bind();
      // Prezzo aggiornato PRIMA di qualsiasi rendering decorativo: se una
      // delle render sotto muore su un browser vecchio, il totale resta giusto.
      this.recalc();
      this.renderStrand('cordino');
      this.renderColors('cordino');
      this.showColors('cordino');
      this.renderTextColors();
      this.applyTagPhoto();
      if (this.els.config) {
        this.els.config.dataset.frasiStepActive = '1';
        const spread = this.data.slotSpread != null ? this.data.slotSpread : 8;
        this.els.config.style.setProperty('--gg-frasi-slot-gap', spread + 'px');
      }
      this.renderSlots();
      this.recalc();
      this.updatePreviewLayout();
      this._onResize = () => {
        this.renderSlots(); // ricalcola l'arco: raggio/larghezza slot dipendono dallo stage
        this.updatePreviewLayout();
      };
      window.addEventListener('resize', this._onResize);
    }

    bind() {
      this.root.querySelectorAll('[data-cord]').forEach((btn) => {
        btn.addEventListener('click', () => this.selectCord(btn));
      });

      this.root.querySelectorAll('[data-shape]').forEach((btn) => {
        btn.addEventListener('click', () => this.selectShape(btn));
      });

      this.root.querySelectorAll('[data-charm]').forEach((btn) => {
        btn.addEventListener('click', (e) => {
          if (e.target.closest('[data-qty-plus], [data-qty-minus]')) return;
          this.addCharmFromCard(btn);
        });
        const plus = btn.querySelector('[data-qty-plus]');
        const minus = btn.querySelector('[data-qty-minus]');
        if (plus) {
          plus.addEventListener('click', (e) => {
            e.stopPropagation();
            this.addCharmFromCard(btn);
          });
        }
        if (minus) {
          minus.addEventListener('click', (e) => {
            e.stopPropagation();
            this.removeCharmByKey(btn.dataset.charm);
          });
        }
      });

      this.root.querySelectorAll('[data-frasi-go]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const target = Number(btn.dataset.frasiGo);
          // gate del passo 3 (Marco 08/08): senza frase non si va avanti,
          // cosi' al riepilogo con frase vuota non ci si arriva proprio
          if (target >= 4 && !this.state.frase.trim()) {
            this.go(3);
            this.showFraseError('Scrivi la tua frase per continuare.');
            return;
          }
          this.go(target);
        });
      });

      if (this.els.input) {
        this.els.input.addEventListener('input', (e) => this.typePhrase(e.target.value));
      }

      // Dropdown mobile step 1 (call 18/07): pilotano le stesse card/swatch nascoste
      if (this.els.cordSelect) {
        this.els.cordSelect.addEventListener('change', () => {
          const btn = this.root.querySelector(`[data-cord="${this.els.cordSelect.value}"]`);
          if (btn) this.selectCord(btn);
        });
      }
      if (this.els.colorSelect) {
        this.els.colorSelect.addEventListener('change', () => {
          const box = this.root.querySelector(`[data-frasi-colors="${this.state.cord}"]`);
          const sws = box ? box.querySelectorAll('.gg-frasi-sw') : [];
          const sw = sws[this.els.colorSelect.selectedIndex];
          if (sw) sw.click();
        });
      }

      if (this.els.addBtn) {
        this.els.addBtn.addEventListener('click', () => this.addToCart());
      }

      document.addEventListener('gg-frasi:start', () => this.showConfigurator());
    }

    showConfigurator() {
      if (this.els.config) this.els.config.classList.add('is-visible');
      document.querySelectorAll('.gg-frasi-intro-wrapper').forEach((section) => {
        section.classList.add('is-hidden');
      });
      const inspo = document.querySelector('[data-frasi-inspo]');
      if (inspo) inspo.classList.add('is-hidden');
      window.scrollTo({ top: this.root.offsetTop - 20, behavior: 'smooth' });
    }

    selectCord(el) {
      this.root
        .querySelectorAll('[data-cord-wrap]')
        .forEach((o) => o.classList.remove('is-selected'));
      const wrap = el.closest('[data-cord-wrap]');
      if (wrap) wrap.classList.add('is-selected');
      this.state.cord = el.dataset.cord;
      // idem: il totale non deve dipendere dai passaggi grafici che seguono
      this.recalc();
      if (this.els.cordSelect) this.els.cordSelect.value = this.state.cord;
      this.renderStrand(el.dataset.strand || 'cordino');
      this.renderColors(this.state.cord);
      this.showColors(this.state.cord);
      this.recalc();
      this.updatePreviewLayout();
    }

    showColors(cord) {
      this.root.querySelectorAll('[data-frasi-colors]').forEach((el) => {
        el.classList.toggle('is-active', el.dataset.frasiColors === cord);
      });
    }

    applyCordThumb(color) {
      const thumb = this.root.querySelector(`[data-frasi-cordthumb="${this.state.cord}"]`);
      const img = thumb && thumb.querySelector('img');
      const src = (color && color.image) || (img && img.dataset.defaultSrc) || '';
      if (img && src) img.src = src;
      this.applyPreviewPhoto(src);
    }

    applyPreviewPhoto(src) {
      const photo = this.root.querySelector('[data-frasi-preview-photo]');
      if (!photo) return;
      if (this.els.preview) this.els.preview.classList.toggle('has-photo', !!src);
      if (src) {
        photo.src = src;
        photo.hidden = false;
        // la curva dipende dalla foto: riposiziona gli slot quando è caricata/layoutata
        if (photo.complete && photo.offsetWidth > 0) {
          this.renderSlots();
        } else {
          photo.onload = () => this.renderSlots();
        }
      } else {
        photo.hidden = true;
        this.renderSlots();
      }
      this.updatePreviewLayout();
    }

    // Layer assoluto sopra la foto dove vivono gli slot in modalità "curva reale"
    ensureCurveLayer() {
      if (this._curveLayer && this._curveLayer.parentNode) return this._curveLayer;
      const layer = document.createElement('div');
      layer.className = 'gg-frasi-curve-layer';
      this.els.previewStage.appendChild(layer);
      this._curveLayer = layer;
      return layer;
    }

    renderColors(cord) {
      const box = this.root.querySelector(`[data-frasi-colors="${cord}"]`);
      if (!box) return;
      const list = (this.data.colors && this.data.colors[cord]) || [];
      box.innerHTML = '';
      if (this.els.colorSelect) {
        this.els.colorSelect.innerHTML = list
          .map((c) => `<option value="${esc(c.name)}">${esc(c.name)}</option>`)
          .join('');
      }
      if (!list.length) {
        this.state.color = '';
        this.state.colorHex = '';
        return;
      }

      const lbl = document.createElement('div');
      lbl.className = 'gg-frasi-colorlbl';
      box.appendChild(lbl);

      // default: primo colore del cordino
      this.state.color = list[0].name;
      this.state.colorHex = list[0].hex;

      list.forEach((c, idx) => {
        const sw = document.createElement('button');
        sw.type = 'button';
        sw.className = 'gg-frasi-sw' + (idx === 0 ? ' is-selected' : '');
        paintSwatch(sw, c);
        sw.title = c.name;
        sw.setAttribute('aria-label', `Colore ${c.name}`);
        sw.addEventListener('click', () => this.selectColor(box, sw, c));
        box.appendChild(sw);
      });

      if (this.els.colorSelect) this.els.colorSelect.value = this.state.color;
      this.updateColorLabel();
      this.applyStrandColor(this.state.colorHex);
      this.applyCordThumb(list[0]);
    }

    selectColor(box, sw, color) {
      box.querySelectorAll('.gg-frasi-sw').forEach((o) => o.classList.remove('is-selected'));
      sw.classList.add('is-selected');
      this.state.color = color.name;
      this.state.colorHex = color.hex;
      if (this.els.colorSelect) this.els.colorSelect.value = this.state.color;
      this.updateColorLabel();
      this.applyStrandColor(color.hex);
      this.applyCordThumb(color);
      this.recalc();
    }

    updateColorLabel() {
      const box = this.root.querySelector(`[data-frasi-colors="${this.state.cord}"]`);
      const lbl = box && box.querySelector('.gg-frasi-colorlbl');
      if (lbl) lbl.innerHTML = `Colore: <b>${this.state.color || '—'}</b>`;
    }

    // Supplemento scritta multicolore (Marco 07/08): il prezzo vive su una
    // variante vera (prodotto nascosto scelto da editor), perche' al checkout
    // Shopify addebita le varianti, non il totale mostrato. Senza prodotto
    // configurato il supplemento semplicemente non esiste (ne' badge ne' costo).
    mcSupplement() {
      const mc = this.data.multicolorSupplement;
      return mc && mc.variantId && typeof mc.price === 'number' ? mc : null;
    }

    mcActive() {
      return !!(this.mcSupplement() && this.state.textColor && isMulticolor(this.state.textColor));
    }

    // Palette colore scritta (call 18/07): swatch fissi definiti da editor tema
    renderTextColors() {
      const box = this.els.textColors;
      const list = Array.isArray(this.data.textColors) ? this.data.textColors : [];
      if (!box || !list.length) return;
      box.innerHTML = '';
      const lbl = document.createElement('div');
      lbl.className = 'gg-frasi-colorlbl';
      box.appendChild(lbl);
      list.forEach((c, idx) => {
        const sw = document.createElement('button');
        sw.type = 'button';
        sw.className = 'gg-frasi-sw' + (idx === 0 ? ' is-selected' : '');
        paintSwatch(sw, c);
        sw.title = c.name;
        sw.setAttribute('aria-label', `Colore scritta ${c.name}`);
        if (isMulticolor(c) && this.mcSupplement()) {
          const chip = document.createElement('span');
          chip.className = 'gg-frasi-sw__extra';
          chip.textContent = `+${fmtMoneyCompact(this.mcSupplement().price)}`;
          sw.appendChild(chip);
          sw.setAttribute('aria-label', `Colore scritta ${c.name}, supplemento ${fmtMoneyCompact(this.mcSupplement().price)}`);
        }
        sw.addEventListener('click', () => {
          box.querySelectorAll('.gg-frasi-sw').forEach((o) => o.classList.remove('is-selected'));
          sw.classList.add('is-selected');
          this.applyTextColor(c);
        });
        box.appendChild(sw);
      });
      this.applyTextColor(list[0]);
    }

    applyTextColor(c) {
      this.state.textColor = c;
      // "Multicolor" (Luca 23/07, riconfermato il 01/08) non e' un colore
      // piatto: la frase prende il gradiente vero e proprio, non un colore
      // medio che non dice nulla.
      if (this.els.word) {
        const multi = isMulticolor(c);
        this.els.word.classList.toggle('is-multicolor', multi);
        this.els.word.style.color = multi ? '' : c.hex;
      }
      const box = this.els.textColors;
      const lbl = box && box.querySelector('.gg-frasi-colorlbl');
      if (lbl) {
        const extra = this.mcActive() ? ` <span class="gg-frasi-colorlbl__extra">(+${fmtMoneyCompact(this.mcSupplement().price)})</span>` : '';
        lbl.innerHTML = `Colore scritta: <b>${esc(c.name)}</b>${extra}`;
      }
      // il colore della scritta ora puo' toccare il totale (multicolor +3 €)
      this.recalc();
    }

    applyStrandColor(hex) {
      if (!this.els.strand || !hex) return;
      const cord = this.els.strand.querySelector('.strand-cord');
      if (cord) cord.style.background = hex;
      this.els.strand.querySelectorAll('.bead').forEach((b) => {
        b.style.background = hex;
      });
      this.els.strand.querySelectorAll('.link').forEach((l) => {
        l.style.borderColor = hex;
      });
    }

    selectShape(el) {
      this.root.querySelectorAll('[data-shape]').forEach((o) => o.classList.remove('is-selected'));
      el.classList.add('is-selected');
      this.state.shape = el.dataset.shape;
      if (this.els.tag) this.els.tag.className = `gg-frasi-tag shape-${this.state.shape}`;
      this.applyTagPhoto();
      // la targhetta scelta scende dall'alto e si aggancia al cordino
      if (this.els.tag) this.els.tag.classList.add('gg-drop-in');
      this.recalc();
      this.updatePreviewLayout();
    }

    // Targhetta fotografica: se c'è la foto per la forma scelta, la usa come
    // sfondo del tag (la frase resta sovrapposta); senza foto resta il tag CSS.
    // Il tag prende le proporzioni REALI del PNG: dimensioni = naturali × k
    // (--gg-frasi-tagphoto-k, per breakpoint) × tag-scale.
    applyTagPhoto() {
      const tag = this.els.tag;
      if (!tag) return;
      const src = (this.data.tagPhotos || {})[this.state.shape];
      if (!src) {
        tag.classList.remove('has-tag-photo');
        tag.style.backgroundImage = '';
        tag.style.width = '';
        tag.style.height = '';
        this._markTagPhotoReady();
        return;
      }
      tag.classList.add('has-tag-photo');
      tag.style.backgroundImage = `url("${src}")`;
      this._tagImgCache = this._tagImgCache || {};
      const applySize = (w, h) => {
        tag.style.width = `calc(${w}px * var(--gg-frasi-tagphoto-k, 0.15) * var(--gg-frasi-tag-scale, 1))`;
        tag.style.height = `calc(${h}px * var(--gg-frasi-tagphoto-k, 0.15) * var(--gg-frasi-tag-scale, 1))`;
        this.renderSlots(); // la clearance degli slot e il pin della hangrow dipendono dal tag
        this.updatePreviewLayout();
        this._markTagPhotoReady();
      };
      const cached = this._tagImgCache[src];
      if (cached) {
        applySize(cached.w, cached.h);
        return;
      }
      this._tagPhotoReady = false;
      const img = new Image();
      img.onload = () => {
        this._tagImgCache[src] = { w: img.naturalWidth, h: img.naturalHeight };
        applySize(img.naturalWidth, img.naturalHeight);
      };
      img.src = src;
    }

    // Segnala che le dimensioni reali della targhetta sono applicate e sveglia
    // chi stava aspettando (vedi onTagPhotoReady).
    _markTagPhotoReady() {
      this._tagPhotoReady = true;
      this._tagPhotoReadyCbs.splice(0).forEach((cb) => cb());
    }

    // Esegue cb subito se la foto della targhetta ha già le dimensioni reali
    // applicate, altrimenti la mette in coda finché applyTagPhoto() non finisce.
    onTagPhotoReady(cb) {
      if (this._tagPhotoReady) cb();
      else this._tagPhotoReadyCbs.push(cb);
    }

    /* ---------- Slot + ciondolini (piazzamento AUTOMATICO, call 18/07) ---------- */

    filledSlots() {
      return this.state.slots.filter(Boolean);
    }

    filledCount() {
      return this.state.slots.reduce((n, s) => n + (s ? 1 : 0), 0);
    }

    // k-esimo ciondolino piazzato → indice slot: pari a destra, dispari a sinistra
    // (1° slot destra, 2° sinistra, 3° destra, …), sempre adiacenti alla targhetta.
    slotIndexFor(k) {
      const nPer = this.slotsPerSide;
      const r = Math.floor(k / 2); // 0 = adiacente alla targhetta
      return k % 2 === 0 ? nPer + r : nPer - 1 - r;
    }

    // Ricostruisce gli slot dall'ordine di piazzamento: alla rimozione di un
    // ciondolino gli altri "scivolano" a ricompattarsi verso la targhetta.
    rebuildSlots() {
      this.state.slots = new Array(this.maxCharms).fill(null);
      this.state.order.forEach((charm, k) => {
        this.state.slots[this.slotIndexFor(k)] = charm;
      });
    }

    // Costruisce l'oggetto ciondolino a partire dal bottone addon dello step 4:
    // cattura la chiave, il nome e l'immagine/emoji da mostrare nello slot.
    addonCharm(btn) {
      const key = btn.dataset.charm;
      const meta = this.charms[key] || {};
      const imgEl = btn.querySelector('.gg-frasi-addon__img');
      const emojiEl = btn.querySelector('.gg-frasi-addon__emoji');
      return {
        key,
        name: meta.name || key,
        img: imgEl ? imgEl.getAttribute('src') : '',
        emoji: emojiEl ? emojiEl.textContent.trim() : '✨',
      };
    }

    slotMediaHtml(charm) {
      return charm.img
        ? `<img src="${charm.img}" alt="${esc(charm.name)}" draggable="false">`
        : `<span class="gg-frasi-slot__emoji">${esc(charm.emoji)}</span>`;
    }

    renderSlots() {
      const left = this.els.slotsLeft;
      const right = this.els.slotsRight;
      if (!left || !right) return;
      left.innerHTML = '';
      right.innerHTML = '';
      if (this._curveLayer) this._curveLayer.innerHTML = '';

      const nPer = this.slotsPerSide;
      const vgap = this.data.slotVGap != null ? this.data.slotVGap : 1;
      const spread = this.data.slotSpread != null ? this.data.slotSpread : 8;

      // MODALITÀ CURVA REALE: se la foto base è una delle ufficiali, targhetta e
      // slot vengono appesi sulla collana fotografata (curva estratta offline).
      const photo = this.root.querySelector('[data-frasi-preview-photo]');
      const hasPhoto = this.els.preview && this.els.preview.classList.contains('has-photo');
      const curvePts = hasPhoto && photo && !photo.hidden ? curveForPhoto(photo.getAttribute('src')) : null;
      if (curvePts && photo.offsetWidth > 0) {
        try {
          this.renderSlotsOnCurve(curvePts, photo, nPer, spread, vgap);
          this.updatePreviewLayout();
          return;
        } catch (err) {
          // la curva e' decorazione: se fallisce si ripiega sull'arco
          // parametrico qui sotto invece di bloccare prezzi e step
          if (window.console && console.warn) console.warn('gg-frasi: curva slot fallita', err);
        }
      }
      this._curveMode = false;
      // reset del pinning curva sulla hangrow
      const hangEl = this.root.querySelector('.gg-frasi-hangrow');
      if (hangEl) {
        hangEl.style.top = '';
        hangEl.style.bottom = '';
      }

      // --- FALLBACK: arco parametrico (foto caricate da editor senza curva nota) ---
      const curve = this.data.slotCurve != null ? this.data.slotCurve : 1.4;
      const exp = this.data.slotExp != null ? this.data.slotExp : 1.6;
      const stageW = (this.els.previewStage && this.els.previewStage.clientWidth) || 900;
      const R = hasPhoto ? stageW * 0.4 : 350; // raggio arco
      // Stesso ingrandimento della modalità curva (Luca 01/08). Qui non serve
      // il controllo sui bordi: l'arco è disegnato dentro un contenitore che
      // updatePreviewLayout rimpicciolisce da solo se sborda dall'anteprima.
      const W = (hasPhoto ? Math.max(30, Math.min(54, stageW * 0.105)) : 54) * CHARM_ENLARGE; // larghezza slot (px)
      const thetaMax = Math.min(1.45, Math.max(0.22, 0.5 * curve));
      const hFactor = (spread || 0) / 8; // 8 (default) → 1

      // k = 0 (vicino alla targhetta) ... nPer-1 (esterno); angoli uguali
      const posArc = [];
      for (let k = 0; k < nPer; k++) {
        const frac = Math.pow((k + 1) / nPer, exp / 1.6); // exp=1.6 → lineare (equidistante)
        const a = thetaMax * frac;
        posArc[k] = {
          x: R * Math.sin(a) * hFactor, // offset orizzontale dal centro
          depth: R * (Math.cos(a) - Math.cos(thetaMax)) * vgap, // profondità (interno più giù)
        };
      }
      const contW = posArc[nPer - 1].x + W;
      const contH = posArc[0].depth + W + 14;
      // Con la foto: alza l'arco della profondità massima, così lo slot esterno
      // cavalca la collana fotografata invece di pendere sotto il bordo.
      const liftY = hasPhoto ? posArc[0].depth : 0;
      [left, right].forEach((c) => {
        c.style.width = `calc(${contW}px * var(--gg-frasi-charm-scale))`;
        c.style.height = `calc(${contH}px * var(--gg-frasi-charm-scale))`;
      });

      this.state.slots.forEach((item, i) => {
        const onLeft = i < nPer;
        const posOuterToInner = onLeft ? i : this.maxCharms - 1 - i; // 0 esterno ... nPer-1 interno
        const k = nPer - 1 - posOuterToInner; // 0 interno ... nPer-1 esterno
        const { x, depth } = posArc[k];

        const slot = document.createElement('div');
        slot.className = 'gg-frasi-slot' + (item ? ' is-filled' : '');
        slot.dataset.frasiSlot = String(i);
        slot.style.position = 'absolute';
        slot.style.width = `calc(${W}px * var(--gg-frasi-charm-scale))`;
        slot.style.height = `calc(${W}px * var(--gg-frasi-charm-scale))`;
        slot.style.marginTop = '0';
        slot.style.top = `calc(${12 + depth - liftY}px * var(--gg-frasi-charm-scale))`;
        // il lato sinistro è ancorato a destra (verso la targhetta), il destro a sinistra
        if (onLeft) {
          slot.style.right = `calc(${x}px * var(--gg-frasi-charm-scale))`;
        } else {
          slot.style.left = `calc(${x}px * var(--gg-frasi-charm-scale))`;
        }

        if (item) {
          slot.innerHTML = this.slotMediaHtml(item);
          if (i === this._dropIndex) slot.classList.add('gg-drop-in');
        }

        (onLeft ? left : right).appendChild(slot);
      });
      this._dropIndex = null;

      this.updatePreviewLayout();
    }

    // Slot e targhetta appesi alla collana FOTOGRAFATA: cammina lungo la curva
    // a distanza d'arco costante partendo dal centro (dove pende la targhetta).
    renderSlotsOnCurve(curvePts, photo, nPer, spread, vgap) {
      this._curveMode = true;
      const layer = this.ensureCurveLayer();
      const offX = photo.offsetLeft;
      const offY = photo.offsetTop;
      const photoW = photo.offsetWidth;
      const photoH = photo.offsetHeight;
      const table = buildArcTable(curvePts, photoW, photoH);

      const spreadPx = (spread - 8) * 1.5; // slider Larghezza: 8 = neutro
      const vOff = (vgap - 1) * 14; // slider Distanza verticale: 1 = neutro

      // targhetta al centro: aggancia la hangrow al punto centrale della curva
      const sC = table.sAtX(photoW / 2);
      const pC = table.at(sC);
      const tag = this.els.tag;
      const tagW = tag ? tag.offsetWidth : 70;
      const tagH = tag ? tag.offsetHeight : 80;
      const hang = this.root.querySelector('.gg-frasi-hangrow');
      if (hang) {
        hang.style.bottom = 'auto';
        hang.style.top = `${offY + pC.y - tagH * 0.06 + vOff}px`;
      }
      // i contenitori flex laterali non servono in questa modalità
      [this.els.slotsLeft, this.els.slotsRight].forEach((c) => {
        c.style.width = '0px';
        c.style.height = '0px';
      });

      // --- Quanto grandi possono essere i ciondolini ---------------------------
      // Luca (01/08) li vuole più grandi. La misura non è però libera: i
      // ciondolini pendono da una collana FOTOGRAFATA, quindi più crescono più
      // il loro arco si allarga e più i due esterni rischiano di uscire dal
      // riquadro o di toccarsi. Invece di scegliere un numero e sperare, si
      // parte dal +20% e si verifica se ci sta: se non ci sta si stringe prima
      // la spaziatura, poi la misura, mai sotto quella di prima. Così con 1-4
      // ciondolini (il caso normale) si vede il +20% pieno, e nel caso limite
      // di tutti gli slot occupati su anteprima stretta non si peggiora nulla.
      const baseW = Math.max(38, Math.min(76, photoW * 0.14));
      let W = baseW * CHARM_ENLARGE;

      // Solo gli slot PIENI devono starci: quelli vuoti sono invisibili e il
      // riempimento va dall'interno verso l'esterno, quindi con pochi
      // ciondolini l'arco resta corto e c'è tutto lo spazio per ingrandirli.
      let rMax = -1;
      this.state.slots.forEach((item, i) => {
        if (item) rMax = Math.max(rMax, i < nPer ? nPer - 1 - i : i - nPer);
      });

      // Un ciondolino "ci sta" se il suo riquadro resta dentro la foto con un
      // margine di sicurezza: sul bordo esatto sembrerebbe comunque tagliato.
      const fitsAt = (s, w) => {
        const p = table.at(s);
        const pad = 3 + w * 0.04;
        const top = p.y - w * 0.12 + vOff;
        return (
          p.x - w / 2 >= pad &&
          p.x + w / 2 <= photoW - pad &&
          top >= pad &&
          top + w <= photoH - pad
        );
      };
      // Distanza d'arco massima (per lato) a cui un ciondolino largo w sta
      // ancora dentro: la zona buona è un intervallo intorno al centro, quindi
      // basta una ricerca binaria invece di camminare tutta la curva.
      const maxOffset = (w) => {
        let lo = 0;
        let hi = table.total;
        for (let i = 0; i < 18; i++) {
          const mid = (lo + hi) / 2;
          if (fitsAt(sC - mid, w) && fitsAt(sC + mid, w)) lo = mid;
          else hi = mid;
        }
        return lo;
      };

      let clearance = 0;
      let gapStep = 0;
      let avail = 0;
      for (let guard = 0; guard < 14; guard++) {
        clearance = tagW / 2 + W * 0.65 + Math.max(0, spreadPx);
        gapStep = W * 1.18 + spreadPx;
        if (rMax < 0) break; // nessun ciondolino scelto: niente da far stare
        avail = maxOffset(W);
        // CHARM_MIN_GAP è il passo sotto cui due ciondolini si toccherebbero:
        // è un vincolo, non una preferenza, quindi non risente dello slider.
        if (clearance + rMax * W * CHARM_MIN_GAP <= avail) break;
        if (W <= baseW + 0.01) break; // già alla misura di prima: non si stringe oltre
        W = Math.max(baseW, W * 0.97); // passo piccolo: si cede il minimo indispensabile
      }
      if (rMax > 0) {
        // spaziatura preferita, ma compressa quel tanto che serve a far
        // rientrare i due esterni — e mai fino a farli sovrapporre.
        gapStep = Math.max(W * CHARM_MIN_GAP, Math.min(gapStep, (avail - clearance) / rMax));
      }

      this.state.slots.forEach((item, i) => {
        const onLeft = i < nPer;
        const r = onLeft ? nPer - 1 - i : i - nPer; // 0 = più vicino alla targhetta
        const sOff = clearance + r * gapStep;
        const p = table.at(onLeft ? sC - sOff : sC + sOff);

        const slot = document.createElement('div');
        slot.className = 'gg-frasi-slot' + (item ? ' is-filled' : '');
        slot.dataset.frasiSlot = String(i);
        slot.style.position = 'absolute';
        slot.style.width = `${W}px`;
        slot.style.height = `${W}px`;
        slot.style.marginTop = '0';
        slot.style.left = `${offX + p.x - W / 2}px`;
        // l'anello del ciondolo sfiora la collana: lieve sovrapposizione verso l'alto
        slot.style.top = `${offY + p.y - W * 0.12 + vOff}px`;

        if (item) {
          slot.innerHTML = this.slotMediaHtml(item);
          if (i === this._dropIndex) slot.classList.add('gg-drop-in');
        }

        layer.appendChild(slot);
      });
      this._dropIndex = null;
    }

    // Aggiunge 1 ciondolino dal card (tap sul card o sul +): posizione automatica
    addCharmFromCard(card) {
      if (card.classList.contains('is-disabled')) return;
      if (this.state.order.length >= this.maxCharms) {
        this.flashFull();
        return;
      }
      this.state.order.push({ ...this.addonCharm(card) });
      this.rebuildSlots();
      this._dropIndex = this.slotIndexFor(this.state.order.length - 1); // anima solo il nuovo
      this.renderSlots();
      this.recalc();
    }

    // Toglie l'ULTIMO ciondolino piazzato di quel tipo (bottone −); gli altri scivolano
    removeCharmByKey(key) {
      for (let k = this.state.order.length - 1; k >= 0; k--) {
        if (this.state.order[k].key === key) {
          this.state.order.splice(k, 1);
          this.rebuildSlots();
          this.renderSlots();
          this.recalc();
          return;
        }
      }
    }

    // Sincronizza i contatori quantità sulle card con gli slot piazzati
    renderAddonCounts() {
      const counts = {};
      this.state.slots.forEach((s) => {
        if (s) counts[s.key] = (counts[s.key] || 0) + 1;
      });
      this.root.querySelectorAll('[data-charm]').forEach((card) => {
        const n = counts[card.dataset.charm] || 0;
        const el = card.querySelector('[data-qty-count]');
        if (el) el.textContent = String(n);
        const minus = card.querySelector('[data-qty-minus]');
        if (minus) minus.disabled = n === 0;
        card.classList.toggle('has-qty', n > 0);
      });
    }

    flashFull() {
      this.root.querySelectorAll('.gg-frasi-slot').forEach((s) => {
        s.classList.add('is-busy');
        setTimeout(() => s.classList.remove('is-busy'), 400);
      });
    }

    typePhrase(value) {
      this.hideFraseError();
      let lines = wrapPhrase(value);
      if (lines.length > LINES_MAX || usefulLength(lines) > CHARS_MAX) {
        // non sta in 3 righe da 12 caratteri: tronca al prefisso piu' lungo
        // che ci sta ancora (bug B3, Marco 24/08) — mai piu' un campo
        // svuotato di colpo. Scrivendo lettera per lettera il prefisso valido
        // coincide con quanto gia' battuto (si perde solo l'ultimo carattere,
        // come prima); incollando una frase troppo lunga il campo mostra la
        // parte che entra invece di azzerarsi.
        value = truncateToFit(value);
        lines = wrapPhrase(value);
        if (this.els.input) this.els.input.value = value;
        if (this.els.note) this.els.note.classList.add('is-full');
      } else if (this.els.note) {
        this.els.note.classList.remove('is-full');
      }
      this.state.frase = value;
      if (this.els.word) this.els.word.textContent = lines.length ? lines.join('\n') : 'la tua frase';
      if (this.els.tag) this.els.tag.dataset.lines = String(Math.max(1, lines.length));
      // il contatore segue i caratteri incisi, non quelli battuti: gli spazi
      // diventati a capo non si vedono sulla targhetta e non vanno addebitati
      if (this.els.count) this.els.count.textContent = String(usefulLength(lines));
      this.fitPhrase();
    }

    /* La frase riempie la targhetta: il font non è più fisso per numero di righe,
       ma è il più grande che sta nello spazio utile del tag. Una frase corta
       diventa quindi molto più leggibile di una da 10 caratteri per riga. */
    fitPhrase() {
      const word = this.els.word;
      const tag = this.els.tag;
      if (!word || !tag) return;
      const box = tag.getBoundingClientRect();
      if (!box.width || !box.height) return;

      const cs = getComputedStyle(tag);
      let availW = box.width - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
      let availH = box.height - parseFloat(cs.paddingTop) - parseFloat(cs.paddingBottom);
      // forma rettangolare: la frase è ruotata di 90°, larghezza e altezza si scambiano
      if (tag.classList.contains('shape-rettangolare')) {
        const t = availW;
        availW = availH;
        availH = t;
      }
      // rotonda: il testo vive nel quadrato inscritto, non nel bounding box
      if (tag.classList.contains('shape-rotonda')) {
        availW *= 0.82;
        availH *= 0.82;
      }
      if (availW <= 0 || availH <= 0) return;

      const rows = String(word.textContent || '').split('\n');
      const longest = rows.reduce((a, r) => (r.length > a.length ? r : a), '');
      if (!longest) return;

      // larghezza del testo a 100px, misurata una volta per font e contenuto
      const probe = GgFrasiConfigurator._probe || (GgFrasiConfigurator._probe = (() => {
        const el = document.createElement('span');
        el.setAttribute('aria-hidden', 'true');
        el.style.cssText = 'position:absolute;left:-9999px;top:0;white-space:pre;pointer-events:none;';
        document.body.appendChild(el);
        return el;
      })());
      const wcs = getComputedStyle(word);
      probe.style.font = '100px/1 ' + wcs.fontFamily;
      probe.style.fontWeight = wcs.fontWeight;
      probe.style.letterSpacing = wcs.letterSpacing;
      probe.textContent = longest;
      const wAt100 = probe.getBoundingClientRect().width;
      if (!wAt100) return;

      // interlinea stretta sul multiriga: il manoscritto ha glifi piccoli
      // rispetto all'em, quindi anche sotto 1 resta aria tra le righe.
      // Su mobile la targhetta è piccola e va compattata ancora di più.
      const narrow = window.matchMedia('(max-width: 1023.98px)').matches;
      const lineH = rows.length >= 3
        ? (narrow ? 0.72 : 0.78)
        : rows.length === 2
          ? (narrow ? 0.76 : 0.82)
          : 1.05;
      const byWidth = (availW / wAt100) * 100 * 0.96;
      const byHeight = availH / (rows.length * lineH);
      // tetto: una frase di due lettere non deve diventare sproporzionata
      const cap = availH * 0.62;
      const size = Math.max(7, Math.min(byWidth, byHeight, cap));
      word.style.fontSize = size.toFixed(2) + 'px';
      word.style.lineHeight = String(lineH);
    }

    renderStrand(type) {
      if (!this.els.strand) return;
      if (type === 'perline') {
        this.els.strand.innerHTML = Array.from({ length: 20 }, () => '<i class="bead"></i>').join('');
      } else if (type === 'catenina') {
        this.els.strand.innerHTML = Array.from({ length: 15 }, () => '<i class="link"></i>').join('');
      } else {
        this.els.strand.innerHTML = '<div class="strand-cord"></div>';
      }
      this.updatePreviewLayout();
    }

    updatePreviewLayout() {
      const preview = this.els.preview;
      const stage = this.els.previewStage;
      const scaleWrap = this.els.previewScale;
      if (!preview || !stage || !scaleWrap) return;

      const count = this.filledCount();
      preview.dataset.charmCount = String(count);
      preview.classList.toggle('has-charms', count > 0);

      // il tag può aver cambiato dimensione (forma, scala, resize): rimisura la frase
      requestAnimationFrame(() => this.fitPhrase());

      // Modalità curva reale: dimensioni già ancorate alla foto, niente auto-shrink
      if (this._curveMode) {
        preview.style.setProperty('--gg-frasi-tag-scale', '1');
        preview.style.setProperty('--gg-frasi-charm-scale', '1');
        preview.style.setProperty('--gg-frasi-strand-scale', '1');
        preview.classList.remove('is-preview-scaled');
        return;
      }

      let tagScale = TAG_SCALE_BY_COUNT[count] ?? 0.68;
      let charmScale = CHARM_SCALE_BY_COUNT[count] ?? 0.68;
      let strandScale = 1;

      const applyScales = () => {
        preview.style.setProperty('--gg-frasi-tag-scale', String(tagScale));
        preview.style.setProperty('--gg-frasi-charm-scale', String(charmScale));
        preview.style.setProperty('--gg-frasi-strand-scale', String(strandScale));
      };

      applyScales();
      stage.style.transform = '';
      scaleWrap.style.height = '';
      preview.classList.remove('is-preview-scaled');

      requestAnimationFrame(() => {
        // Con la foto lo stage è un quadrato fisso: si scala solo la hangrow perché stia dentro
        if (preview.classList.contains('has-photo')) {
          const hangrow = this.root.querySelector('.gg-frasi-hangrow');
          const available = stage.clientWidth * 0.92;
          const needed = hangrow ? hangrow.offsetWidth : 0;
          if (needed > available && available > 0) {
            const layoutScale = Math.max(0.4, available / needed);
            tagScale *= layoutScale;
            charmScale *= layoutScale;
            applyScales();
            preview.classList.add('is-preview-scaled');
          }
          return;
        }

        const available = preview.clientWidth - 24;
        const needed = stage.scrollWidth;

        if (needed > available && available > 0) {
          const layoutScale = Math.max(0.5, available / needed);
          tagScale *= layoutScale;
          charmScale *= layoutScale;
          strandScale *= layoutScale;
          applyScales();
          preview.classList.add('is-preview-scaled');
        }

        this.syncStrandWidth();
      });
    }

    syncStrandWidth() {
      const hangrow = this.root.querySelector('.gg-frasi-hangrow');
      const strand = this.els.strand;
      if (!hangrow || !strand) return;

      const count = this.filledCount();
      const cord = strand.querySelector('.strand-cord');

      if (count === 0) {
        strand.style.width = '';
        if (cord) cord.style.width = '';
        return;
      }

      const w = Math.ceil(hangrow.offsetWidth);
      strand.style.width = `${w}px`;
      if (cord) cord.style.width = '100%';
    }

    getVariant() {
      return findVariantByState(this.data.variants || [], this.state);
    }

    totalCents() {
      const variant = this.getVariant();
      let total = variant ? variant.price : 3200;
      const fallback = this.data.charmPrice || 1200;
      this.filledSlots().forEach((s) => {
        const meta = this.charms[s.key];
        total += meta && typeof meta.price === 'number' ? meta.price : fallback;
      });
      if (this.mcActive()) total += this.mcSupplement().price;
      return total;
    }

    recalc() {
      this.renderAddonCounts();
      const total = this.totalCents();
      const formatted = fmtMoney(total);
      this.els.prices.forEach((el) => {
        el.textContent = formatted;
      });
      if (this.els.klarna && this.els.klarnaRate) {
        if (total >= 4000) {
          this.els.klarna.style.display = 'block';
          this.els.klarnaRate.textContent = fmtMoney(total / 3);
        } else {
          this.els.klarna.style.display = 'none';
        }
      }
    }

    go(step) {
      if (step === 5) this.buildSummary();

      this.els.steps.forEach((s) => {
        s.classList.toggle('is-active', Number(s.dataset.frasiStep) === step);
      });

      // opzione B: gli slot vuoti compaiono solo allo step 4
      if (this.els.config) this.els.config.dataset.frasiStepActive = String(step);

      // la targhetta entra in scena allo step 2 (prima è nascosta) con la caduta dall'alto
      if (step === 2 && !this._tagIntroDone && this.els.tag) {
        this._tagIntroDone = true;
        const tag = this.els.tag;
        // Marco 02/09: il fix del 01/09 aspettava la foto del CORDINO
        // (frasi-preview-photo), non quella della TARGHETTA — sono due
        // immagini diverse. Se si arriva qui subito (senza toccare nulla),
        // applyTagPhoto() dello shape di default puo' essere ancora a meta'
        // caricamento: far partire la caduta prima che le dimensioni reali
        // siano applicate aggancia la targhetta alla posizione sbagliata,
        // poi il resize la sposta a meta' animazione. Si aspetta
        // onTagPhotoReady (vedi applyTagPhoto), non la foto del cordino.
        const startDrop = () => {
          tag.classList.remove('gg-drop-in');
          void tag.offsetWidth;
          tag.classList.add('gg-drop-in');
        };
        this.onTagPhotoReady(startDrop);
      }

      const labels = {
        1: 'Passo 1 di 4',
        2: 'Passo 2 di 4',
        3: 'Passo 3 di 4',
        4: 'Passo 4 di 4',
        5: 'Ci siamo!',
      };
      if (this.els.progTxt) this.els.progTxt.textContent = labels[step] || '';
      if (this.els.progBar) this.els.progBar.style.width = `${step >= 5 ? 100 : step * 25}%`;

      if (step === 3 && this.els.input) {
        setTimeout(() => this.els.input.focus(), 320);
      }

      if (step === 4 || step === 5) {
        requestAnimationFrame(() => this.updatePreviewLayout());
      }

      this.root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    buildSummary() {
      const cordWrap = this.root.querySelector('[data-cord-wrap].is-selected');
      const cordNameEl = cordWrap && cordWrap.querySelector('.gg-frasi-cordname');
      const cordLbl = cordNameEl ? cordNameEl.textContent.trim() : 'Cordino';
      const shapeLbl = SHAPE_LABELS[this.state.shape] || this.state.shape;
      const counts = {};
      this.state.slots.forEach((c) => {
        if (c) counts[c.key] = (counts[c.key] || 0) + 1;
      });
      const charmKeys = Object.keys(counts);
      const charmName = (k) => (this.charms[k] && this.charms[k].name) || k;
      const charmTxt = charmKeys.length
        ? charmKeys
            .map((k) => (counts[k] > 1 ? `${charmName(k)} ×${counts[k]}` : charmName(k)))
            .join(', ')
        : 'nessuno';

      if (this.els.summary) {
        // Etichetta "Collana" e non "Cordino" (Marco 06/08): il valore accanto
        // e' gia' il tipo scelto (Cordino/Perline/Catenina), la riga dice cosa
        // e' l'oggetto, non una delle sue varianti.
        this.els.summary.innerHTML =
          `<b>Collana:</b> ${cordLbl}<br>` +
          (this.state.color ? `<b>Colore:</b> ${this.state.color}<br>` : '') +
          `<b>Forma:</b> ${shapeLbl}<br>` +
          `<b>Frase:</b> «${esc(this.state.frase) || '—'}»<br>` +
          (this.state.textColor
            ? `<b>Colore scritta:</b> ${esc(this.state.textColor.name)}${this.mcActive() ? ` (+${fmtMoneyCompact(this.mcSupplement().price)})` : ''}<br>`
            : '') +
          `<b>Ciondolini:</b> ${charmTxt}`;
      }
      this.recalc();
    }

    showError(msg) {
      if (!this.els.error) return;
      this.els.error.textContent = msg;
      this.els.error.classList.add('is-visible');
    }

    showFraseError(msg) {
      const box = this.root.querySelector('[data-frasi-error-frase]');
      if (!box) return;
      box.textContent = msg;
      box.classList.add('is-visible');
      if (this.els.input) this.els.input.focus();
    }

    hideFraseError() {
      const box = this.root.querySelector('[data-frasi-error-frase]');
      if (box) box.classList.remove('is-visible');
    }

    hideError() {
      if (this.els.error) this.els.error.classList.remove('is-visible');
    }

    async addToCart() {
      this.hideError();

      if (!this.state.frase.trim()) {
        // l'errore va mostrato nel passo 3, dove l'utente atterra: quello del
        // passo 5 sparirebbe insieme al riepilogo (rimbalzo muto, Marco 08/08)
        this.go(3);
        this.showFraseError('Scrivi la tua frase prima di aggiungere al carrello.');
        return;
      }

      const variant = this.getVariant();
      if (!variant) {
        this.showError('Variante non trovata. Controlla le opzioni prodotto in Shopify.');
        return;
      }

      const configId = `${Date.now()}`;
      const shapeLbl = SHAPE_LABELS[this.state.shape] || this.state.shape;

      const charmCounts = {};
      this.state.slots.forEach((c) => {
        if (c) charmCounts[c.key] = (charmCounts[c.key] || 0) + 1;
      });
      // Niente piu' "Ciondolini:" scritto sulla riga della collana (Luca,
      // call 14/08 + doc "Bug fixing" 18/08): quella nota veniva scritta una
      // volta sola all'add e restava anche se il ciondolo veniva tolto dopo
      // (es. al checkout, dove le righe bundle non sono piu' nascoste) —
      // l'ordine mostrava un ciondolo mai pagato. L'informazione ora vive
      // solo sulla riga del ciondolo stesso: se sparisce lui, sparisce
      // anche l'informazione, niente disallineamento possibile.
      const mainProps = {
        Frase: this.state.frase.trim(),
        Forma: shapeLbl,
        Colore: this.state.color || '—',
        'Colore scritta': this.state.textColor ? this.state.textColor.name : '—',
        _config_id: configId,
      };

      const items = [
        {
          id: variant.id,
          quantity: 1,
          properties: mainProps,
        },
      ];
      Object.keys(charmCounts).forEach((key) => {
        const charmVariantId = this.charms[key] && this.charms[key].variantId;
        if (charmVariantId) {
          items.push({
            id: charmVariantId,
            quantity: charmCounts[key],
            properties: {
              _bundle: 'frasi',
              _config_id: configId,
            },
          });
        }
      });

      // supplemento scritta multicolore: riga a parte come i ciondolini,
      // legata alla collana dallo stesso _config_id
      if (this.mcActive()) {
        items.push({
          id: this.mcSupplement().variantId,
          quantity: 1,
          properties: {
            _bundle: 'frasi',
            _config_id: configId,
          },
        });
      }

      if (this.els.addBtn) this.els.addBtn.classList.add('is-loading');

      try {
        const res = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items }),
        });

        const body = await res.json();
        if (!res.ok) throw new Error(body.description || body.message || 'Errore carrello');

        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
      } catch (err) {
        this.showError(err.message || 'Non siamo riusciti ad aggiungere al carrello.');
      } finally {
        if (this.els.addBtn) this.els.addBtn.classList.remove('is-loading');
      }
    }
  }

  class GgFrasiIntro {
    constructor(root) {
      this.track = root.querySelector('[data-frasi-track]');
      this.slideshow = root.querySelector('.gg-frasi-slideshow');
      this.slides = root.querySelectorAll('[data-frasi-slide]');
      this.dots = root.querySelectorAll('[data-frasi-dot]');
      if (!this.track || this.slides.length < 2) return;

      // Le slide tengono la loro proporzione (Marco 03/08): il riquadro
      // insegue l'altezza della slide attiva; media caricati dopo e resize
      // rifanno la misura.
      this.slides.forEach((s) => {
        const m = s.querySelector('.gg-frasi-slide__img');
        if (!m) return;
        m.addEventListener('load', () => this.syncHeight());
        m.addEventListener('loadedmetadata', () => this.syncHeight());
      });
      window.addEventListener('resize', () => this.syncHeight());

      this.dragging = false;
      this.startX = 0;
      this.startScroll = 0;
      this.timer = null;

      this.dots.forEach((dot, i) => {
        dot.addEventListener('click', () => {
          clearInterval(this.timer);
          this.goTo(i, true);
        });
      });

      this.track.addEventListener(
        'scroll',
        () => window.requestAnimationFrame(() => {
          this.syncDots();
          this.syncHeight();
        }),
        { passive: true }
      );

      // Drag col mouse su desktop — il touch usa lo scroll nativo del browser.
      this.track.addEventListener('pointerdown', (e) => {
        if (e.pointerType === 'touch') return;
        this.dragging = true;
        this.startX = e.clientX;
        this.startScroll = this.track.scrollLeft;
        this.track.classList.add('is-dragging');
        this.track.setPointerCapture(e.pointerId);
        clearInterval(this.timer);
      });

      this.track.addEventListener('pointermove', (e) => {
        if (!this.dragging) return;
        this.track.scrollLeft = this.startScroll - (e.clientX - this.startX);
      });

      const endDrag = () => {
        if (!this.dragging) return;
        this.dragging = false;
        this.track.classList.remove('is-dragging');
      };
      this.track.addEventListener('pointerup', endDrag);
      this.track.addEventListener('pointercancel', endDrag);
      this.track.addEventListener('pointerleave', (e) => {
        if (this.dragging && e.pointerType !== 'touch') endDrag();
      });

      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        // "Secondi per slide" dall'editor (Marco 08/08); 3500 resta il ripiego
        // se l'attributo manca (markup vecchio in cache)
        const slideMs = parseInt(this.slideshow && this.slideshow.dataset.frasiSlideMs, 10) || 3500;
        this.timer = setInterval(() => this.goTo(this.currentIndex() + 1, true), slideMs);
      }

      this.syncDots();
      this.syncHeight();
    }

    currentIndex() {
      return Math.round(this.track.scrollLeft / this.track.clientWidth);
    }

    syncHeight() {
      if (!this.slideshow) return;
      const slide = this.slides[this.currentIndex()];
      if (!slide) return;
      const h = slide.offsetHeight;
      if (h > 40) this.slideshow.style.height = h + 'px';
    }

    goTo(i, smooth) {
      const count = this.slides.length;
      const idx = (i + count) % count;
      this.track.scrollTo({ left: idx * this.track.clientWidth, behavior: smooth ? 'smooth' : 'auto' });
    }

    syncDots() {
      const i = this.currentIndex();
      this.dots.forEach((dot, di) => {
        dot.classList.toggle('is-active', di === i);
      });
    }
  }

  /* La CTA "Inizia a creare" e' fissa in fondo allo schermo ed e' rossa quanto
     il footer: scendendo a fine pagina i due si sovrapponevano e il bottone
     spariva (Marco 05/08). Qui si guarda solo SE si toccano e si mette la
     classe: l'inversione dei colori la fa il CSS in gg-frasi-intro.css.
     Il controllo parte solo quando il bottone e' davvero fissato (su desktop
     sta nel flusso e il problema non esiste). */
  class GgFrasiStickyCta {
    constructor(btn) {
      this.btn = btn;
      this.footer = document.querySelector('.gg-chrome-footer');
      if (!this.footer) return;
      this.pending = false;
      this.onScroll = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll, { passive: true });
      this.sync();
    }

    onScroll() {
      // un solo calcolo per frame: lo scroll su mobile spara molti piu' eventi
      if (this.pending) return;
      this.pending = true;
      requestAnimationFrame(() => {
        this.pending = false;
        this.sync();
      });
    }

    sync() {
      if (getComputedStyle(this.btn).position !== 'fixed') {
        this.btn.classList.remove('is-on-footer');
        return;
      }
      const btn = this.btn.getBoundingClientRect();
      const footer = this.footer.getBoundingClientRect();
      const overlap = footer.top < btn.bottom && footer.bottom > btn.top;
      this.btn.classList.toggle('is-on-footer', overlap);
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-gg-frasi-intro]').forEach((el) => new GgFrasiIntro(el));

    document.querySelectorAll('[data-gg-frasi-root]').forEach((el) => new GgFrasiConfigurator(el));

    document.querySelectorAll('[data-frasi-start]').forEach((btn) => {
      new GgFrasiStickyCta(btn);

      btn.addEventListener('click', () => {
        document.dispatchEvent(new CustomEvent('gg-frasi:start'));
      });
    });
  });
})();
